import { render, staticRenderFns } from "./IntegratedSuccesfullyPage.vue?vue&type=template&id=62d0f159&"
import script from "./IntegratedSuccesfullyPage.vue?vue&type=script&lang=js&"
export * from "./IntegratedSuccesfullyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports